import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Grid } from "@mui/material";
import { useInView } from "react-intersection-observer";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
// import { useGetMonthlyApplicationCountQuery } from "apis/ApplicationRequestDetail";

import BreadCrumb from "Components/Common/BreadCrumb";
// import ApplicationTypesPieChart from "Components/Charts/ApplicationTypesPieChart";
// import MonthlyApplicationTypeBarChart from "Components/Charts/MonthlyApplicationTypeBarChart";
import CategoryWiseNumberOfConsumerPieChart from "Components/Charts/CategoryWiseNumberOfConsumerPieChart";
import CategoryWiseNumberOfConsumerBarChart from "Components/Charts/CategoryWiseNumberOfConsumerBarChart";
import TariffWiseConsumersPieChart from "Components/Charts/TariffWiseConsumersPieChart";
import TariffWiseConsumersBarChart from "Components/Charts/TariffWiseConsumersBarChart";
import ActiveConsumerChart from "Components/Charts/ActiveConsumerChart";
import ActiveTariffChart from "Components/Charts/ActiveTariffChart";
// import MeteringStatusChart from "Components/Charts/MeteringStatusChart";
import { chartColors, powerApplicationsRoles } from "common/constant";
import NumberOfComplaintsBarChart from "Components/Charts/NumberOfComplaintsBarChart";
import NumberOfComplaintsPieChart from "Components/Charts/NumberOfComplaintsPieChart";
import SopGERCChart from "Components/Charts/SopGERCChart";
import Backdrop from "Components/Common/Backdrop";
import DatePicker from "Components/Common/DatePicker";

import { dateFormatter } from "utils/dateFormatter";
import getChartData from "utils/getChartData";
import { isAuthorizedUser } from "utils";

import {
  useGetLazyConsumerActivatedDisconnectedCategoryWiseQuery,
  useGetLazyConsumerActivatedDisconnectedTariffWiseQuery,
  useGetLazyConsumerCategoryWiseQuery,
  useGetLazyConsumerTariffWiseWiseQuery,
  useGetLazySopConsumerCategoryQuery,
} from "apis/UtilityConsumer/utilityConsumer";
import { useLazyNoOfConsumerComplaintsQuery } from "apis/ConsumerComplaint";

const Dashboard = ({ t }) => {
  const { ref: activeConsumerChartRef, inView: isActiveConsumerChartInView } =
    useInView({
      triggerOnce: true,
    });

  const { ref: activeTariffChardRef, inView: isActiveTariffChartInView } =
    useInView({
      triggerOnce: true,
    });

  const { ref: sopGERCChartRef, inView: isSoapGERCChartInView } = useInView({
    triggerOnce: true,
  });

  const {
    ref: NumberOfComplaintsBarChartRef,
    inView: isNumberOfComplaintsBarChartInView,
  } = useInView({
    triggerOnce: true,
  });

  const { roles } = useSelector((state) => state.Login);

  // const { data: { data: monthlyApplicationTypesData } = {} } =
  //   useGetMonthlyApplicationCountQuery();

  const [
    getConsumerCategoryData,
    {
      data: { data: { utilityConsumerMonthWise } = {} } = {},
      isLoading: isConsumerCategoryWiseLoading,
      isFetching: isConsumerCategoryWiseFetching,
    },
  ] = useGetLazyConsumerCategoryWiseQuery();

  const [
    getConsumerTariffData,
    {
      data: { data: { tariffRecords } = {} } = {},
      isLoading: isConsumerTariffWiseLoading,
      isFetching: isConsumerTariffWiseFetching,
    },
  ] = useGetLazyConsumerTariffWiseWiseQuery();

  const [
    getConsumerActivatedDisconnectedCategoryWiseData,
    {
      data: {
        data: {
          activatedAndDisconnectedMonthWise:
            categoryWiseActiveInactiveConsumers,
        } = {},
      } = {},
      isLoading: isActiveConsumerCategoryWiseLoading,
      isFetching: isActiveConsumerCategoryWiseFetching,
    },
  ] = useGetLazyConsumerActivatedDisconnectedCategoryWiseQuery();

  const [
    getConsumerActivatedDisconnectedTariffWiseData,
    {
      data: {
        data: {
          activatedAndDisconnectedMonthWise: tariffWiseActiveInactiveConsumers,
        } = {},
      } = {},
      isLoading: isActiveConsumerTariffWiseLoading,
      isFetching: isActiveConsumerTariffWiseFetching,
    },
  ] = useGetLazyConsumerActivatedDisconnectedTariffWiseQuery();

  const [
    getSopConsumerCategoryData,
    {
      data: { data: sopGERCData } = {},
      isLoading: isSopLoading,
      isFetching: isSopFetching,
    },
  ] = useGetLazySopConsumerCategoryQuery();

  const [
    getNoOfComplaintsData,
    {
      data: { data: { consumerComplaintDataList } = {} } = {},
      isLoading: isConsumerComplaintsLoading,
      isFetching: isConsumerComplaintsFetching,
    },
  ] = useLazyNoOfConsumerComplaintsQuery();

  // const [selectedApplicationType, setSelectedApplicationType] = useState({
  //   title: "LT Permanent Connection",
  //   color: chartColors[0],
  //   index: 0,
  // });

  const isLoading = useMemo(
    () =>
      isConsumerCategoryWiseLoading ||
      isConsumerTariffWiseLoading ||
      isActiveConsumerCategoryWiseLoading ||
      isActiveConsumerTariffWiseLoading ||
      isSopLoading ||
      isConsumerComplaintsLoading ||
      isConsumerCategoryWiseFetching ||
      isConsumerTariffWiseFetching ||
      isConsumerComplaintsFetching ||
      isSopFetching ||
      isActiveConsumerTariffWiseFetching ||
      isActiveConsumerCategoryWiseFetching,
    [
      isConsumerCategoryWiseLoading,
      isConsumerTariffWiseLoading,
      isActiveConsumerCategoryWiseLoading,
      isActiveConsumerTariffWiseLoading,
      isSopLoading,
      isConsumerCategoryWiseFetching,
      isConsumerComplaintsLoading,
      isConsumerTariffWiseFetching,
      isConsumerComplaintsFetching,
      isSopFetching,
      isActiveConsumerTariffWiseFetching,
      isActiveConsumerCategoryWiseFetching,
    ]
  );

  const [categoryType, setCategoryType] = useState({
    title: "",
    color: chartColors[0],
  });

  const [tariffType, setTariffType] = useState({
    title: "",
    color: chartColors[0],
  });

  // const [
  //   barChartDataForMonthlyApplicationTypes,
  //   setBarChartDataForMonthlyApplicationTypes,
  // ] = useState({});
  // const [
  //   pieChartLabelForMonthlyApplicationType,
  //   setPieChartLabelForMonthlyApplicationType,
  // ] = useState([]);
  // const [
  //   pieChartDataForMonthlyApplicationType,
  //   setPieChartDataForMonthlyApplicationType,
  // ] = useState([]);
  const [tariffSeries, setTariffSeries] = useState([]);
  const [tariffLabels, setTariffLabels] = useState([]);
  const [consumerSeries, setConsumerSeries] = useState([]);
  const [consumerLabels, setConsumerLabels] = useState([]);

  const [numberOfConsumerSeries, setNumberOfConsumerSeries] = useState({});
  const [numberOfConsumerLabels, setNumberOfConsumerLabels] = useState([]);
  const [complaintTitle, setComplaintTitle] = useState("");
  const [complaintTitleIndex, setComplaintTitleIndex] = useState(0);
  const [query, setQuery] = useState({ year: null });

  // useEffect(() => {
  //   if (monthlyApplicationTypesData) {
  //     const barData = monthlyApplicationTypesData.reduce(
  //       (prevApplicationType, currentApplicationType) => {
  //         const formattedApplicationTypeName =
  //           currentApplicationType.applicationTypeName.split("_").join(" ");
  //         prevApplicationType[formattedApplicationTypeName] = Object.values(
  //           currentApplicationType.monthlyApplicationCountReport
  //         );

  //         return prevApplicationType;
  //       },
  //       {}
  //     );
  //     const pieLabels = Object.keys(barData);
  //     const pieData = Object.values(barData).map((data) =>
  //       data.reduce((acc, curr) => (acc += curr), 0)
  //     );
  //     setBarChartDataForMonthlyApplicationTypes(barData);
  //     setPieChartLabelForMonthlyApplicationType(pieLabels);
  //     setPieChartDataForMonthlyApplicationType(pieData);
  //   }
  // }, [monthlyApplicationTypesData]);

  const isPowerAdmin = useMemo(
    () => isAuthorizedUser(roles, powerApplicationsRoles),
    [roles]
  );

  useEffect(() => {
    if (utilityConsumerMonthWise) {
      setCategoryType((prev) => ({
        ...prev,
        title:
          utilityConsumerMonthWise[0].utilityConsumerCategoryCount[0].category,
      }));
      const { pieLabels, pieChartData } = getChartData(
        utilityConsumerMonthWise,
        "utilityConsumerCategoryCount",
        "category",
        "count",
        "month"
      );
      setConsumerSeries(pieChartData);
      setConsumerLabels(pieLabels);
    }
  }, [utilityConsumerMonthWise]);

  useEffect(() => {
    if (tariffRecords) {
      setTariffType((prev) => ({
        ...prev,
        title: tariffRecords[0].tariffDetails[0].tariffName,
      }));
      const { pieLabels, pieChartData } = getChartData(
        tariffRecords,
        "tariffDetails",
        "tariffName",
        "count",
        "month"
      );
      setTariffSeries(pieChartData);
      setTariffLabels(pieLabels);
    }
  }, [tariffRecords]);

  useEffect(() => {
    if (consumerComplaintDataList?.length) {
      setComplaintTitle(consumerComplaintDataList[0].classificationOfComplaint);
      const { barChartData, barChartLabels } = getChartData(
        consumerComplaintDataList,
        "consumerComplaintTypes",
        "category",
        "count",
        "classificationOfComplaint"
      );
      setNumberOfConsumerLabels(barChartLabels);
      setNumberOfConsumerSeries(barChartData);
    } else {
      setNumberOfConsumerLabels([]);
      setNumberOfConsumerSeries({});
      setComplaintTitle("");
    }
  }, [consumerComplaintDataList]);

  useEffect(() => {
    if (isPowerAdmin) {
      try {
        const queryParam = {
          year: query.year ? query.year.format("YYYY") : "",
        };
        getConsumerCategoryData(queryParam);
        getConsumerTariffData(queryParam);
        getConsumerActivatedDisconnectedTariffWiseData(queryParam);
        getConsumerActivatedDisconnectedCategoryWiseData(queryParam);
        getSopConsumerCategoryData(queryParam);
        getNoOfComplaintsData(queryParam);
      } catch (err) {
        console.error(err);
      }
    }
  }, [isPowerAdmin, query]);

  return (
    <div className="page-content">
      <BreadCrumb title={t("Dashboard")} />
      {isPowerAdmin && (
        <>
          <Backdrop open={isLoading} />
          <Grid container rowSpacing={2}>
            {/* <Grid item xs={12}>
          <Card className="overflow-auto d-flex flex-column">
            <Grid container>
              <Grid item xs={12} md={6} xl={5}>
                <ApplicationTypesPieChart
                  changeApplicationType={setSelectedApplicationType}
                  data={pieChartDataForMonthlyApplicationType}
                  labels={pieChartLabelForMonthlyApplicationType}
                />
              </Grid>
              <Grid item xs={12} md={6} xl={7}>
                <MonthlyApplicationTypeBarChart
                  applicationType={selectedApplicationType}
                  data={barChartDataForMonthlyApplicationTypes}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid> */}
            <Grid item xs={8} sm={5} md={4} lg={3}>
              <DatePicker
                slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                label={t("Select Year")}
                className="w-100"
                views={["year"]}
                format={dateFormatter(query.year)}
                value={query.year}
                disableFuture
                onChange={(date) => {
                  setQuery({
                    year: date,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Card className="overflow-auto d-flex flex-column">
                <Grid container>
                  <Grid item xs={12} md={6} xl={5}>
                    <CategoryWiseNumberOfConsumerPieChart
                      changeCategoryType={setCategoryType}
                      data={consumerSeries}
                      labels={consumerLabels}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} xl={7}>
                    <CategoryWiseNumberOfConsumerBarChart
                      categoryType={categoryType}
                      utilityConsumerMonthWise={utilityConsumerMonthWise}
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card className="overflow-auto d-flex flex-column">
                <Grid container>
                  <Grid item xs={12} md={6} lg={5}>
                    <TariffWiseConsumersPieChart
                      changeTariffType={setTariffType}
                      data={tariffSeries}
                      labels={tariffLabels}
                      // tariffRecords={tariffRecords}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={7}>
                    <TariffWiseConsumersBarChart
                      tariffType={tariffType}
                      tariffRecords={tariffRecords}
                    />
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid item xs={12} ref={activeConsumerChartRef}>
              {isActiveConsumerChartInView && (
                <ActiveConsumerChart
                  categoryWiseActiveInactiveConsumers={
                    categoryWiseActiveInactiveConsumers
                  }
                />
              )}
            </Grid>

            <Grid item ref={activeTariffChardRef} xs={12}>
              {isActiveTariffChartInView && (
                <ActiveTariffChart
                  tariffWiseActiveInactiveConsumers={
                    tariffWiseActiveInactiveConsumers
                  }
                />
              )}
            </Grid>

            {/* <Grid item xs={12}>
          <MeteringStatusChart />
        </Grid> */}

            <Grid item xs={12} ref={sopGERCChartRef}>
              {isSoapGERCChartInView && (
                <SopGERCChart sopGERCData={sopGERCData} />
              )}
            </Grid>

            {/* <CategoryWiseNumberOfConsumerPieChart
                  changeCategoryType={setCategoryType}
                  data={consumerSeries}
                  labels={consumerLabels}
                /> */}
            {/* <CategoryWiseNumberOfConsumerBarChart
              categoryType={categoryType}
              utilityConsumerMonthWise={utilityConsumerMonthWise}
            /> */}
            <Grid ref={NumberOfComplaintsBarChartRef} item xs={12}>
              {isNumberOfComplaintsBarChartInView && (
                <Card className="overflow-auto d-flex flex-column">
                  <Grid container>
                    <Grid item xs={12} md={6} xl={7}>
                      <NumberOfComplaintsBarChart
                        series={numberOfConsumerSeries}
                        labels={numberOfConsumerLabels}
                        setComplaintTitle={setComplaintTitle}
                        setComplaintTitleIndex={setComplaintTitleIndex}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} xl={5}>
                      <NumberOfComplaintsPieChart
                        data={numberOfConsumerSeries}
                        complaintTitle={complaintTitle}
                        complaintTitleIndex={complaintTitleIndex}
                      />
                    </Grid>
                  </Grid>
                </Card>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

Dashboard.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(Dashboard);
